/** Format value with 2 decimal places; nullish → null so InfoField renders N/A */
export const formatFloat = (value: number | string | null | undefined): string | null => {
  if (value == null) return null;
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  if (isNaN(numValue)) return '0.00';
  return numValue.toFixed(2);
};
